<template>
  <div>
    <div v-if="$store.state.hasLogin">
      <!-- <div class="processBar" v-show="!processBar.hide">
        <div class="process-bg"></div>
        <div class="process-go" v-bind:style="{width: processBar.process}"></div>
      </div> -->
      <div class="header" v-if="$store.state.hasLogin">
        <span class="togoMenu" v-on:click="handleMenu()">
          <span class="icon-unfold fas fa-bars"></span>
        </span>
        <span v-on:click="toConsole" class="title">
          <img
            src="../assets/image/logo_wh.png"
            width="170"
            alt="logo"
            class="logo-default"
          />
        </span>

        <!-- <boss-bar ref="bossBar"></boss-bar> -->
        <span class="log">
          <!-- <el-select v-model="brandCode" size="mini" @change="changeBrand" :disabled="filterBrandList.length === 1">
            <el-option
              v-for="item in filterBrandList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select> -->

          <p class="logout-box">
            <span class="logout" @click="passwordDialogVisible = true"
              >密码修改</span
            >
            <span class="logout">|</span>
            <span class="logout update-psw" @click="clickLogout">退出</span>
          </p>
          <span class="title-tips"
            >您好，{{
              $store.state.userInfo.adminUserName
            }}，欢迎使用SCM系统!</span
          >
        </span>
      </div>
      <div class="tree-container" v-if="$store.state.hasLogin">
        <div class="tree">
          <Tree></Tree>
        </div>

        <div class="content">
          <el-tabs
            v-model="menuTabValues"
            closable
            @tab-remove="removeTab"
            @tab-click="onTabClick"
            style="background: #fff;"
          >
            <el-tab-pane
              v-for="item in renderMenu"
              :key="item.name"
              :label="item.title"
              :name="item.name"
            ></el-tab-pane>
            <keep-alive>
              <router-view v-if="$route.path != '/lc-iframe'"></router-view>
            </keep-alive>
            <!-- keep-alive对低代码页面的iframe不生效, 用v-show来控制切换tab时页面不刷新 -->
            <LCIframe v-show="$route.path == '/lc-iframe'" />
          </el-tabs>
          <!-- <div style="padding-top: 25px;" v-show="$store.state.LC_PAGE">
            <div style="padding-left: 20px; background: #fff;">
              <page-bar>
                <page-bar-item :label="label"></page-bar-item>
              </page-bar>
            </div> -->
          <!-- <div id="subApp-lcscm-logic"></div> -->
          <!-- <div id="subApp-lcscm-cost"></div>
            <div id="subApp-lcscm-user"></div>
            <div id="subApp-lcscm-data"></div> -->
          <!-- </div> -->
        </div>
      </div>
    </div>
    <passwordChangeDialog
      :passwordDialogVisible="passwordDialogVisible"
      @close="close"
    />
  </div>
</template>
<script>
import Tree from "@/components/Tree";
import { mapState, mapActions } from "vuex";
import passwordChangeDialog from "@components/passwordChangeDialog.vue";
import LCIframe from './lcIframe.vue'
export default {
  name: "App",
  provide() {
    return {
      reload: this.reload,
    };
  },
  data() {
    return {
      menuTabValues: this.$route.path,
      menuTabs: [],
      passwordDialogVisible: false,
      isRouterAlive: true,
      originPages: [
        // 需要在content展示的路由名称 ----暂时废弃
        "home",
        "order-manual",
        "production-process",
        "wash-label/list",
        "invoice-allocate/list",
        "invoice-allocate/detail",
        "tag-info",
        "material-category",
        "masterData-feature",
        "store-issue",
        "material-in",
        "goods-inspection/list",
        "cmt-adjust/list",
        "cmt-adjust/detail",
        "fabric-inventory",
        "financial-statement",
        "account-pay",
        "purchase-record",
        "currency-rate",
        "order-ship-export",
        "fabric-out-item-export",
        "advance-order/list",
        "advance-order/detail",
        "planned-cost/board",
        "lc-iframe",
      ],
      includeList: [],
      brandCode: null,
      brandList: [
        {
          label: "Ochirly",
          value: "1",
          orgCode: "OCH",
        },
        {
          label: "FivePlus",
          value: "2",
          orgCode: "FP",
        },
        {
          label: "Trendiano",
          value: "3",
          orgCode: "TRE",
        },
        {
          label: "MissSixty",
          value: "6",
          orgCode: "M60",
        },
        {
          label: "Superdry",
          value: "S",
          orgCode: "SD",
        },
        {
          label: "CovenGarden",
          value: "C",
          orgCode: "CG",
        },
        {
          label: "DENHAM",
          value: "U",
          orgCode: "DENHAM",
        },
        {
          label: "Waxy",
          value: "X",
          orgCode: "WAXY",
        },
        {
          label: "TRENDY",
          value: "GROUP",
          orgCode: "TRENDY",
        },
      ],
    };
  },
  computed: {
    label() {
      return this.$route.query.label;
    },
    menuTitle() {
      return this.$route.params.title ? " " + this.$route.params.title : "";
    },
    filterBrandList() {
      let orgCodes = this.$store.state.gloablInfo.orgCodes;
      if (!orgCodes || !orgCodes.length) {
        return this.brandList;
      }
      return this.brandList.filter((item) => orgCodes.includes(item.orgCode));
    },
    ...mapState({
      hasLogin: (state) => state.hasLogin,
      processBar: (state) => state.processBar,
    }),
    renderMenu() {
      const menus = this.menuTabs;
      const index = menus.findIndex((item) => item.name === "/dashboard");
      if (index > -1) {
        const home = menus.splice(index, 1);
        menus.unshift(home[0]);
      } else {
        menus.unshift({
          title: "首页",
          name: "/dashboard",
          path: "/dashboard",
        });
      }
      return menus;
    },
    computedCacheIframePageList() {
      return this.$store.state.cacheIframePageList
    }
  },
  components: {
    Tree,
    passwordChangeDialog,
    LCIframe
  },
  mounted() {
    console.log(this.$route);
    // console.log('in app.vue mount', 'store.state.hasLogin', this.hasLogin)
    // //监听横向滚动事件
    // window.addEventListener('scroll',()=>{
    //   let commonHeaders=document.getElementsByClassName('page-with-header');
    //   let commonFooters=document.getElementsByClassName('page-with-footer');
    //   if(commonHeaders&&commonHeaders.length>0&&!commonHeaders[0].hasResetWidth){
    //     commonHeaders[0].style.width="100%";
    //     commonHeaders[0].hasResetWidth=true;
    //   }
    //   if(commonFooters&&commonFooters.length>0&&!commonFooters[0].hasResetWidth){
    //     commonFooters[0].style.width="100%";
    //     commonFooters[0].hasResetWidth=true;
    //   }
    // },true);
  },
  methods: {
    ...mapActions(["logout", "toggleMenu", "clearPower"]),
    changeBrand() {
      // switchOrgCode({brandCode: this.brandCode})
      //   .then(res => {
      //     if (!res || !res.success) {
      //       this.$message.error(res.message || '服务端错误')
      //     }
      //   })
      //   .finally(() => {
      //     location.reload()
      //   })
    },
    clickLogout() {
      this.$confirm("确定退出吗?", "", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.logout(this.$store.state.userInfo.id);
          this.$router.push("/login");
        })
        .catch((err) => {});
    },
    toConsole() {
      // window.location.href = CONFIG.sso[process.env.NODE_ENV] + CONFIG.login.ssoUrl
    },
    handleMenu: function () {
      this.toggleMenu();
    },
    reload() {
      this.isRouterAlive = false;
      this.$nextTick(function () {
        this.isRouterAlive = true;
      });
    },
    close() {
      this.passwordDialogVisible = false;
    },
    addTab(targetName, to, from, multiPage = '') {
      let toPath = to.path + multiPage
      const index = this.menuTabs.findIndex((item) => item.name == toPath);
      if (index > -1) {
        this.menuTabValues = toPath;
        return false;
      }
      // 限制tab数量
      if (this.menuTabs.length > 10) {
        alert(`最多同时打开10个页签！`);
        this.$router.push(from.path);
        return;
      }
      this.menuTabs.push({
        title: to.meta.label || to.query.label,
        name: toPath,
        path: to.path,
        meta: to.meta,
        query: to.query,
        params: to.params,
        page: multiPage,
        domain: to.query.domain
      });

      this.menuTabValues = toPath;
    },
    onTabClick() {
      const menuTabValues = this.menuTabValues;
      const router = this.renderMenu.find(item => menuTabValues === item.name);
      if(router && router.domain) {
        this.$store.commit('setLcDomain', router.domain)
      }
      this.$router.push({
        path: router.path,
        query: router.query
      });
    },
    removeTab(targetName) {
      let delIndex;
      let currentActiveInex;
      const menuTabValues = this.menuTabValues;
      this.renderMenu.forEach((item, index) => {
        if(item.name == targetName) delIndex = index
        if(item.name == menuTabValues) currentActiveInex = index
      })
      if(delIndex == 0) return false
      const removeIndex = this.renderMenu.findIndex(item => targetName === item.name);
      this.menuTabs.splice(removeIndex, 1)
      if(delIndex <= currentActiveInex) {
        let nowIndex = currentActiveInex - 1
        let toPath;
        if(nowIndex - 1 >= 0) {
          toPath = this.menuTabs[nowIndex]
        } else {
          toPath = this.menuTabs[0]
        }
        this.menuTabValues = toPath.name
        // 低代码页面删除tab, 也删除掉对应缓存页面
        if(this.$route.path == '/lc-iframe') {
          let delPath = targetName.replace('/lc-iframe','')
          let index = this.computedCacheIframePageList.findIndex(item => item == delPath)
          if(index > -1) {
            this.computedCacheIframePageList.splice(index, 1)
            let iframeContainer = document.querySelector(`#iframe-box`)
            let delPage = document.querySelector(`#${delPath.replaceAll('/', '')}`)
            iframeContainer.removeChild(delPage)
          }
        }
        this.$router.push({
          path: toPath.path,
          query: toPath.query
        })
      }
    }
  },
  watch: {
    // "$route.name": {
    //   handler(val) {
    //     if (this.originPages.includes(val)) {
    //       this.$store.commit("changeShowTscmUserRouter", {
    //         showTscmUserRouter: false,
    //         showTscmLogicRouter: false,
    //         showTscmDataRouter: false,
    //         showBaseRouter: true,
    //       });
    //     }
    //   },
    //   deep: true,
    //   immediate: true,
    // },
    $route: {
      handler: function (to, from) {
        if(this.$route.path != '/lc-iframe') {
          this.addTab(this.menuTabValues, to, from);
        }
      },
      deep: true,
      immediate: true
    },
    // 监听iframe的label变化添加 tab
    "$route.query.page": {
      handler(newVal) {
        if(this.$route.path == '/lc-iframe' && newVal) {
          this.addTab(this.menuTabValues, this.$route, this.$route, this.$route.query.page);
        }
      },
      deep: true,
      immediate: true
    },

  },
};
</script>
<style lang="less" rel="stylesheet/less">
@import "../assets/main.less";
.content {
  height: 96vh;
}

#app {
  .header {
    position: relative;

    .sollapse-bar {
      position: absolute;
      top: 0;
      left: 0;
      height: 40px;
      width: 46px;
      box-sizing: border-box;
      padding: 0;
      margin-top: 0;
      margin-bottom: 15px;
      display: inline-block;

      .sollapse-icon {
        color: #fff;
        width: 46px;
        height: 48px;
        line-height: 48px;
        text-align: center;
        cursor: pointer;
        background-color: #456cf3;
      }

      .sollapse-icon:hover {
        background-color: #456cf3;
      }
    }

    .log .el-select {
      width: 100px;
      margin-right: 20px;

      .el-input__inner {
        color: #999;
        background: transparent;
        border: 1px solid #999;
      }
    }

    .title {
      margin-right: 30px;
      padding-left: 10px;
      cursor: pointer;
    }
    .logout {
      margin-left: 5px;
    }
    .update-psw {
      margin-right: 20px !important;
    }
    .togoMenu {
      display: flex;
      justify-content: center;
      flex-direction: column;
      align-items: center;
      width: 54px;
      height: 40px;
      background: #000;
    }
    .title-tips {
      font-family: PingFangSC-Regular;
      font-size: 12px;
      color: rgba(255, 255, 255, 0.65);
      font-weight: 400;
    }
    .logout-box {
      font-family: PingFangSC-Regular;
      font-size: 12px;
      color: #ffffff;
      font-weight: 400;
    }
  }

  .el-button--text {
    padding-top: 0;
    padding-bottom: 0;
  }
}
body .el-table th.gutter {
  display: table-cell !important;
}
</style>
